export default __webpack_public_path__ + "static/media/20202021.c970ac0d.png";